//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { CenteredSpinner } from '@components/atoms/spinner/Spinner';
import { BodyErrorText } from '@components/atoms/text/Text';
import Cuid from '@models/Cuid';
import { UIATrackingIds } from '@uia/constants/uiaConstants';
import { useMediaMetadataQuery } from '@uia/details/hooks/useMediaMetadataQuery';
import { LabelTagger } from '@uia/labels/tagger/LabelTagger';
import { UIAFooter } from '@uia/layout/UIAFooter';

export interface UIALabelsProps {
  cuid: Cuid;
  onClose: () => void;
}

export const UIALabels = ({ cuid, onClose }: UIALabelsProps) => {
  const { data: metadata, isError, isPending } = useMediaMetadataQuery(cuid);
  return (
    <OverlayWrapper>
      {(() => {
        if (isPending) {
          return (
            <Wrapper>
              <CenteredSpinner />
            </Wrapper>
          );
        } else {
          if (isError) {
            return (
              <BodyErrorText>
                An unexpected error occurred. Please try again or contact
                Bazaarvoice Support.
              </BodyErrorText>
            );
          } else {
            return <LabelTagger cuid={cuid} initialTags={metadata.userTags} />;
          }
        }
      })()}
      <UIAFooter>
        <UIAFooter.Actions>
          <UIAFooter.ActionButton
            onClick={onClose}
            trackingId={UIATrackingIds.LABELS_CLOSE_MODAL}
          >
            Done
          </UIAFooter.ActionButton>
        </UIAFooter.Actions>
      </UIAFooter>
    </OverlayWrapper>
  );
};

const OverlayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
`;

const Wrapper = styled.div(
  ({ theme }) => `
    padding: ${theme.spacings[5]};
  `,
);
